/**
 * Filas de Emitidos que se abren (pulido 2026-10-12): el chevrón de cada factura abre sus conceptos y un clic en la
 * fila hace lo mismo, sin chocar con lo que ya hace la fila (window.FDFilas). Funciones puras, sin DOM ni jQuery: el
 * montaje vive en application/views/noble/documentos/listado.php.
 */
import { esc } from './pestanas.js';

/**
 * Lo que dentro de una fila ya tiene su propio clic: casilla de selección (toda su celda selecciona), enlaces y botones
 * (Cobranza, PDF, XML, notas, correo, cancelar, el «+ 1 pago», el chevrón), campos y la línea hija. Las celdas de
 * Cobranza y de Acciones enteras: un clic que no le atina a un botón por unos píxeles no abre los conceptos.
 */
export const INTERACTIVOS = 'a, button, input, select, textarea, label, [role="button"], [tabindex], '
  + '.dt-select, td:first-child, td.td-cobranza, td.td-acciones, .fd-hija, .dropdown-menu';

/**
 * ¿Un clic en la fila abre o cierra sus conceptos? Solo un clic izquierdo, sencillo (el segundo de un doble clic
 * selecciona una palabra), sin teclas modificadoras, sin texto seleccionado (la persona estaba copiando un folio o un
 * RFC) y fuera de cualquier control de la fila. `e`: {target, button, detail, ctrlKey, metaKey, shiftKey, altKey};
 * `seleccion`: el texto seleccionado en la página.
 */
export function clicAlternaFila(e, seleccion) {
  if (!e || !e.target || typeof e.target.closest !== 'function') return false;
  if ((e.button || 0) !== 0 || (e.detail || 1) > 1) return false;
  if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return false;
  if (String(seleccion == null ? '' : seleccion).trim() !== '') return false;
  return !e.target.closest(INTERACTIVOS);
}

/**
 * ¿Están abiertos los conceptos de la factura `id`? Lo que la persona abrió o cerró en esa fila manda; si no tocó la
 * fila, el interruptor «Ver conceptos» (todas abiertas o todas cerradas).
 */
export function conceptosAbiertos(porFila, id, todas) {
  const f = porFila || {};
  return Object.prototype.hasOwnProperty.call(f, String(id)) ? f[String(id)] === true : todas === true;
}

/** El chevrón junto al folio: abre o cierra los conceptos de esa factura (aria-expanded y aria-controls). */
export function botonFila(id, folio, abierto) {
  const nombre = String(folio == null || folio === '' ? 'esta factura' : folio);
  return '<button type="button" class="fd-fila-toggle" data-id="' + esc(id) + '" aria-expanded="' + (abierto ? 'true' : 'false')
    + '" aria-controls="fd-conceptos-' + esc(id) + '" aria-label="' + esc((abierto ? 'Ocultar' : 'Ver') + ' los conceptos de ' + nombre)
    + '" title="' + esc(abierto ? 'Ocultar los conceptos' : 'Ver los conceptos') + '">'
    + '<i class="ti ti-chevron-right" aria-hidden="true"></i></button>';
}
